/**
 * Shared focusable-element utility for modal focus trapping.
 *
 * Consolidates the duplicate focusable-element definitions that previously
 * lived separately in cross-border-new.js and
 * section-partner-enrollment-page.js. Both now delegate here so the
 * focusable selector is defined in a single place (ECOM-619 #7).
 *
 * The selector intentionally:
 *   - excludes [disabled] controls (they are not tabbable)
 *   - includes [contenteditable="true"]
 *   - excludes [tabindex="-1"] (programmatic-only focus)
 */
(() => {
  if (window.JPFocusUtils) return;

  const FOCUSABLE_SELECTOR =
    'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"]), [contenteditable="true"]';

  const getFocusableElements = (container) => {
    if (!container) return [];
    return Array.prototype.slice.call(container.querySelectorAll(FOCUSABLE_SELECTOR));
  };

  window.JPFocusUtils = {
    FOCUSABLE_SELECTOR: FOCUSABLE_SELECTOR,
    getFocusableElements: getFocusableElements
  };
})();
